import {
  CardContent,
  Divider,
  IconButton,
  Typography,
  makeStyles,
} from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { CardContainer, CardRoot, LocationTypography, ProfileTypography } from "./styles";

type Props = {
  label: string;
  text: string;
  isFocused: boolean;
  setCurrentClip: (clip: any) => void;
};

const AudioCard = ({
  label,
  text,
  setCurrentClip,
  isFocused,
  ...rest
}: Props) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    iconBtn: {
      width: 50,
      height: 50,
      visibility: "hidden"
    },
    playIcon: {
      height: 24,
      width: 24,
      color: "#702BF4",
      fill: "#702BF4",
      
    },
    title: {
      fontSize: 16,
      color: "rgba(0, 0, 0, 0.72)",
    },
    divider: {
      backgroundColor: "#B1B1B1",
    },
  }));

  const classes = useStyles();

  function formatClipDataAndReturnToParent() {
    const clip = {
      playerLabel: `${text} - ${label}`,
      ...rest,
    };

    setCurrentClip(clip);
  }

  return (
    <CardRoot $isFocused={isFocused}>
      <div className={classes.root} onClick={formatClipDataAndReturnToParent}>
        <CardContainer>
          <CardContent>
            <ProfileTypography className={classes.title}>
              {text}
            </ProfileTypography>
            <Divider className={classes.divider} />
            <LocationTypography>
              {label}
            </LocationTypography>
          </CardContent>

          <IconButton
            className={classes.iconBtn}
            aria-label="play/pause"
            onClick={formatClipDataAndReturnToParent}
          >
            <PlayArrowIcon className={classes.playIcon} />
          </IconButton>
        </CardContainer>
      </div>
    </CardRoot>
  );
};

export default AudioCard;
